import { Spinner } from 'react-bootstrap';


export default function Loading({text='Loading...'}) {
    return (
        <Spinner animation="border" role="status" />
    );
}
